import { render, staticRenderFns } from "./Fitxa.vue?vue&type=template&id=b0db8a56&scoped=true&"
import script from "./Fitxa.vue?vue&type=script&lang=js&"
export * from "./Fitxa.vue?vue&type=script&lang=js&"
import style0 from "./Fitxa.vue?vue&type=style&index=0&id=b0db8a56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0db8a56",
  null
  
)

export default component.exports